import { useEffect, useState } from "react"
import { Form, Input, Radio, ConfigProvider, Space, Flex } from 'antd';
import { useTranslation } from "react-i18next";
import { NumType } from "@/status/num";
import './index.less'

export default function TransactionAmount({ form, tokenAInfo }: any) {
	const { t } = useTranslation()
	const [currentSelected, setCurentSelected] = useState(NumType.All);
	const radio = [
		{ label: t("batchSwap.allQuantity"), value: NumType.All },
		{ label: t("batchSwap.fixedQuantity"), value: NumType.Fixed },
		{ label: t("batchSwap.randomQuantity"), value: NumType.RandomAmount },
		{ label: t("batchSwap.randomPercentage"), value: NumType.RandomPercent },
		{ label: t("batchSwap.keepFixedQuantity"), value: NumType.ReservedAmount },
	]

	const onchange = (e: any) => {
		setCurentSelected(e.target.value);
		form.setFieldValue("amountType", e.target.value)
	}

	return (
		<div className='transaction-amount-row'>
			<div className='transaction-amount-col'>
				<ConfigProvider
					theme={{
						components: {
							Radio: {
								buttonBg: "fff",
								buttonColor: "#666666",
								buttonSolidCheckedBg: "var(--primary-color)",
								buttonSolidCheckedColor: "var(--primary-font-color)",
								buttonSolidCheckedHoverBg: "var(--primary-color-hover)",
								buttonSolidCheckedActiveBg: "var(--primary-color-hover)",
								fontSize: 12,
								fontFamily: "PingFang SC, PingFang SC",
								controlHeight: 42
							}
						}
					}}
				>
					<Form.Item
						label={<div className='label-tips'>
							<strong style={{ fontFamily: "PingFang SC" }}>{t("batchSwap.swapNum")}</strong>
						</div>}
						name="amountType"
					>
						<Radio.Group block buttonStyle="solid" onChange={onchange}>
							{
								radio.map((item: any) => {
									return <Radio.Button className="cus-radio-button" key={item.value} value={item.value}>{item.label}</Radio.Button>
								})
							}
						</Radio.Group>
					</Form.Item>
				</ConfigProvider>

			</div>
			<div className='transaction-amount-col'>
				{
					(currentSelected === NumType.Fixed || currentSelected === NumType.ReservedAmount)
					&&
					// <div className="simple-input">
					<Form.Item
						name="quantity"
						label={
							currentSelected === NumType.Fixed
								? <span style={{ fontSize: 12, color: "#000000CC", fontFamily: "PingFang SC" }}>{t("batchSwap.fixedQuantity")}</span>
								: <span style={{ fontSize: 12, color: "#000000CC", fontFamily: "PingFang SC" }}>{t("batchSwap.keepFixedQuantity")}</span>
						}
						rules={[
							{
								required: true,
								message: t("batchSwap.enterQuantity")
							},
							{
								pattern: /^(0|[1-9]\d*)(\.\d+)?$/, // 校验大于 0 的正数
								message: t("warning.enterAValidNumber"),
							},
						]}
					>
						<div className="simple-input">
							<Input
								placeholder={
									currentSelected === NumType.Fixed
										?
										t("batchSwap.enterTheNumberOfTokensPerAddress")
										:
										t("batchSwap.enterTheQuantityToReserveForEachAddress")}
								suffix={tokenAInfo?.symbol}
							/>
						</div>
					</Form.Item>
				}
				{
					(currentSelected === NumType.RandomAmount || currentSelected === NumType.RandomPercent)
					&&
					<div className="custom-input">
						{currentSelected === NumType.RandomAmount && (
							<Flex gap={20} style={{ width: '100%' }}>
								<Flex flex={1}>
									<Form.Item name="minQuantity"
										style={{ flex: 1 }}
										label={<span style={{ fontSize: 12, color: "#000000CC", fontFamily: "PingFang SC" }}>{t("batchSwap.randomQuantity")}</span>}
										rules={[
											{
												required: true,
												message: t("warning.enterMinimumValue")
											},
											{
												pattern: /^(0|[1-9]\d*)(\.\d+)?$/, // 校验大于 0 的正数
												message: t("warning.enterAValidNumber"),
											},
										]}
									>
										<div className="before-input">
											<Input placeholder={t("batchSwap.enterQuantity")} suffix={tokenAInfo?.symbol} />
										</div>
									</Form.Item>
									<span className="delimiter">~</span>
									<Form.Item name="maxQuantity"
										style={{ flex: 1 }}
										label=" "
										rules={[
											({ getFieldValue }) => ({
												validator(_, value) {
													const minQuantity = getFieldValue('minQuantity');

													// 确保 value 和 minPercentage 都是数字
													const numericValue = Number(value);
													const numericMinQuantity = Number(minQuantity);

													if (isNaN(numericValue)) {
														return Promise.reject(new Error(t("warning.enterAValidNumber")));
													}

													// 如果输入值为空或者小于最小值，则返回提示
													if (numericValue < numericMinQuantity) {
														return Promise.reject(new Error(t("warning.inputMustBiggerOrEqual", { num: numericMinQuantity })));
													}

													// 如果校验通过，返回 Promise.resolve
													return Promise.resolve();
												},
											}),
										]}
									>
										<div className="after-input">
											<Input placeholder={t("batchSwap.enterQuantity")} suffix={tokenAInfo?.symbol} />
										</div>
									</Form.Item>
								</Flex>
								<Form.Item name="decimalPlaces"
									label={<span style={{ fontSize: 12, color: "#000000CC", fontFamily: "PingFang SC" }}>{t("batchSwap.decimalPlaces")}</span>}
								>
									<Input className="decimal" />
								</Form.Item>
							</Flex>
						)}
						{currentSelected === NumType.RandomPercent && (
							<Flex style={{ width: '100%' }}>
								<Form.Item name="minPercentage"
									style={{ flex: 1 }}
									label={<span style={{ fontSize: 12, color: "#000000CC", fontFamily: "PingFang SC" }}>{t("batchSwap.randomPercentage")}</span>}
									rules={[
										{
											required: true,
											message: t("warning.enterMinimumValue")
										},
										{
											pattern: /^(100|[1-9][0-9]?)$/,  // 正则验证 1-100 的整数
											message: t("warning.integerInputRange", { min: 1, max: 100 }),
										}
									]}
								>
									<div className="percent-before-input">
										<Input placeholder={t("batchSwap.enterRandomPercentage")} suffix="%" />
									</div>
								</Form.Item>
								<span className="delimiter">~</span>
								<Form.Item name="maxPercentage"
									style={{ flex: 1 }}
									label=" "
									// dependencies={['minPercentage']}
									rules={[
										({ getFieldValue }) => ({
											validator(_, value) {
												const minPercentage = getFieldValue('minPercentage');

												// 确保 value 和 minPercentage 都是数字
												const numericValue = Number(value);
												const numericMinPercentage = Number(minPercentage);

												if (isNaN(numericValue)) {
													return Promise.reject(new Error(t("warning.enterAValidNumber")));
												}

												// 如果输入值为空或者小于最小值，则返回提示
												if (numericValue < numericMinPercentage) {
													return Promise.reject(new Error(t("warning.inputMustBiggerOrEqual", { num: numericMinPercentage })));
												}

												// 如果校验通过，返回 Promise.resolve
												return Promise.resolve();
											},
										}),
									]}
								>
									<div className="percent-after-input">
										<Input
											placeholder={t("batchSwap.enterRandomPercentage")}
											suffix="%"
										/>
									</div>
								</Form.Item>
							</Flex>
						)}
					</div>
				}
			</div>
		</div>
	)
}
